import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createLTD = (payload) => post(baseURL + url.LTD, payload);
export const getLTDDetails = (id) => get(`${baseURL + url.LTD}/${id}`);
export const updateLTD = (id, payload) => put(`${baseURL + url.LTD}/${id}`, payload);
export const deleteLTD = (id) => remove(`${baseURL + url.LTD}/${id}`);
